<template>
  <h3 style="text-align: center" v-if="!Model.Id">
    Incorrect URL.
    <br />
    <br />
    Example:
    {{
      `${origin}/DataPipelineTransformation/Instrument/0B153Z93-E039-41FB-BCF6-12AA81A0FBSN`
    }}
  </h3>

  <div v-if="Model.Id" class="py-4 container-fluid w-75">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="marketWripper">
            <div style="font-size: 1rem">
              <div class="col-md-12" style="margin-top: 24px" />

              <h2 class="text-center">Edit Instrument</h2>
              <div class="col-md-12" style="margin-top: 24px" />

              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Instrument Name:</label
                >
                <argon-input
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  v-model:value.sync="Model.Name"
                />
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Assigned to Market:</label
                >
                <select
                  class="form-select col-sm select customSelect"
                  size="sm"
                  aria-label="Default select example"
                  v-model="Model.MarketId"
                >
                  <option v-if="!Model.MarketId" :value="null" selected>-select-</option>
                  <option v-for="market in Model.Markets" :key="market.Id" :value="market.Id">
                    {{ market.Name }}
                  </option>
                </select>
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="contractType" class="col-sm-2 col-form-label"
                  >Contract Type:</label
                >
                <select
                  class="form-select col-sm select customSelect"
                  size="sm"
                  aria-label="Default select example"
                  v-model="Model.ContractType"
                >
                  <option :value="null" v-bind:selected="!!Model.ContractType">-select-</option>
                  <option v-for="contractType in Model.ContractTypes" :key="contractType.Id" :value="contractType.Id">
                    {{ contractType.Name }}
                  </option>
                </select>
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Description:</label
                >
                <argon-text-area
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  :maxLength="5000"
                  v-model:value.sync="Model.Description"
                >
                </argon-text-area>
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Contract Specification:</label
                >
                <argon-text-area
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  :maxLength="5000"
                  v-model:value.sync="Model.ContractSpecification"
                >
                </argon-text-area>
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="buttons">
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  :isLoading="saveButtonClicked"
                  :isLoadingText="'Saving...'"
                  @click="Save"
                  style="width: 200px; margin-left: 20px"
                  >Save</argon-button
                >
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  @click="Close"
                  style="width: 200px; margin-left: 20px"
                  >Close</argon-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="col-md-12" style="margin-top: 24px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.marketWripper {
  padding: 10px;
}

.buttons {
  text-align: center;
}

.customSelect {
  margin-right: 10px;
  margin-left: 12px;
  height: 40px;
  -webkit-appearance: menulist;
}
</style>
<script>
import {
  ArgonInput,
  ArgonButton,
  ArgonTextArea,
} from "@/components/exporter.js";
import { SendGETServerAPI, SendPOSTServerAPI } from "@/customFunctions/Api.js";
import { Toaster } from "@/customFunctions/Utils.js";

export default {
  name: "data-pipeline-instrument",
  data() {
    return {
      Model: {},
      saveButtonClicked: false,
      component: "",
      origin: window.location.origin,
    };
  },
  async mounted() {
    this.$store.commit("setShowPreloader", true);
    this.component = this.$route.params.pathMatch[0];
    try {
      const regexExp =
        /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      const splittedRoutePath = this.$route.path.split("/");
      const id = regexExp.test(splittedRoutePath[splittedRoutePath.length - 1])
        ? splittedRoutePath[splittedRoutePath.length - 1]
        : "";

      this.Model = await SendGETServerAPI(
        `dataPipelineTransformation/Instrument/${id}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      );

    } catch {
      this.Model = {};
    }

    this.$store.commit("setShowPreloader", false);
  },
  components: { ArgonInput, ArgonButton, ArgonTextArea },
  methods: {
    async Save() {
      this.saveButtonClicked = true;

      const body = {
        Id: this.Model.Id,
        Name: this.Model.Name,
        MarketId: this.Model.MarketId,
        Description: this.Model.Description,
        ContractSpecification: this.Model.ContractSpecification,
        ContractType: this.Model.ContractType
      };
      const resp = await SendPOSTServerAPI(
        "dataPipelineTransformation/Instrument/Edit",
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        },
        JSON.stringify(body)
      ).then((r) => r.json());

      if (resp.isOk) this.Toaster("Data has been saved.", "Success", "success");
      else this.Toaster("Some Server Error...", "Error", "danger");

      this.saveButtonClicked = false;
    },
    Close() {
      window.close();
    },
  },
  setup() {
    return { Toaster };
  },
  watch: {
    "Model.Description"(value) {
      if (!!value && value.length > 5000) {
        Toaster("Description Max Length is 5000...", "Error", "danger");
        return;
      }
    },
  },
};
</script>
